import { AdminApi } from 'stylemix-vue-admin'

export default class VehicleDayNightPricingApi extends AdminApi {
  constructor(parameters = {}) {
    super('vehicles/day-night-pricing', parameters)
  }

  fetchList() {
    return this.submit('get', `/${this.endpoint}`)
  }

  bulkUpdate(payload) {
    return this.submit('put', `/${this.endpoint}`, payload)
  }
}
